import { Dispatch, SetStateAction, createContext, useContext } from "react";
import { Option } from "./types";

/**
 * Context properties for the ListView component
 */
export type ListViewContextProps = {
  /** Array of option objects for focus management */
  options?: Option[];
  /** Callback when selection changes */
  onSelectionChange?: (value: unknown[]) => void;
  /** Currently selected items */
  selectedItems: unknown[];
  /** Currently indeterminate items */
  indeterminateItems: unknown[];
  /** Array of items if using items prop */
  items?: unknown[];
  /** Function to set the selected items */
  setSelectedItems: Dispatch<
    SetStateAction<ListViewContextProps["selectedItems"]>
  >;
  /** Whether the component is controlled */
  controlled?: boolean;
};

export const ListViewContext = createContext<ListViewContextProps | null>(null);

/**
 * Hook to access the listview context
 * @returns The listview context
 * @throws Error if used outside of a ListView component
 */
export function useListView() {
  const context = useContext(ListViewContext);

  if (context == null) {
    throw new Error("useListView must be wrapped in <ListView />");
  }

  return context;
}
